import { Component } from '@angular/core';
import {MsalAuthService} from "../../services/msal-auth.service";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-user-notifications',
  standalone: true,
  imports: [],
  templateUrl: './user-notifications.component.html',
  styleUrl: './user-notifications.component.scss'
})
export class UserNotificationsComponent {

    public showPasswordNotice: boolean = false;
    public showRecoveryNotice: boolean = false;
    public showEmergencyNotice: boolean = false;
    public showO365Notice: boolean = false;

    public get hasAnyNotice(): boolean {
        return ( this.showEmergencyNotice || this.showPasswordNotice || this.showRecoveryNotice );
    }

    constructor(
        private msal: MsalAuthService
    ) {
        // if ( environment.feature_O365 ) {
        //     this.showO365Notice = !this.msal.getHasActiveAccount();
        //     this.msal.hasActiveAccount$.subscribe({
        //         next: (resp: any) => {
        //             this.showO365Notice = !resp;
        //         }
        //     })
        // }
    }

    // public connectO365() {
    //     this.msal.login();
    // }
}
